module.exports = __webpack_public_path__ + "static/media/20.b93b548e.jpg";